import styled, { css } from 'styled-components';
import TextareaAutosize from 'react-textarea-autosize';

import { body } from 'styles/fonts';

import { MainProps, MainTextAreaProps } from './types';

export const Container = styled.div<MainProps>`
  width: 100%;
  display: flex;
  flex-direction: column;

  ${({ theme, error }) => css`
    p {
      color: ${error ? theme.colors.red.main : theme.colors.white.main};
    }
  `}
`;

const commonInputStyles = (error?: string) => css`
  width: 100%;
  outline: none;
  border: 1px solid;
  box-sizing: border-box;

  ${body};

  ${({ theme }) => css`
    color: ${theme.colors.white.main};
    border-radius: ${theme.borderRadius.big};
    background-color: ${theme.colors.grey.main};
    border-color: ${error ? theme.colors.red.main : theme.colors.grey.main};

    &::placeholder {
      color: ${error ? theme.colors.red.main : theme.colors.lightGrey.main};
    }

    &:hover:enabled {
      background-color: ${theme.colors.grey.hover};
    }

    &:active:enabled {
      background-color: ${theme.colors.grey.active};
    }

    &:disabled {
      opacity: 0.5;
    }
  `}
`;

export const StyledInput = styled.input<MainProps>`
  height: 48px;

  ${({ theme, error }) => css`
    ${commonInputStyles(error)};
    padding: 0 ${theme.padding.input};
  `}
`;

export const StyledTextArea = styled(TextareaAutosize)<MainTextAreaProps>`
  resize: none;

  ${({ theme, error, mininputheight }) => css`
    ${commonInputStyles(error)};
    padding: ${theme.padding.input};
    min-height: ${mininputheight ?? '72px'};
  `}
`;

export const EyeBtnContainer = styled.div`
  position: absolute;

  ${({ theme }) => css`
    top: ${theme.padding.input};
    right: ${theme.padding.input};
  `}
`;
